import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { combineReducers } from 'redux';
import { liveReducer } from '../features/live/liveSlice';
import { LoginModalVisibilityReducer } from '../features/login/login.slice';
import { ProfilePageReducer } from '../features/profile/slices/profilePageSlice';
import { RegisterModalReducer } from '../features/register/register.slice';
import { TopPageReducer } from '../features/top/topPageSlice';
import { baseApi } from '../services/api/apiProvider';
import { LiveMissionReducer } from '../features/live/components/LiveMission/LiveMissionSlice';
import { LiveMatchReducer } from '../features/live-match/liveMatchSlice';
import { APP_BASE_URL } from '../loadEnv';

export const history = createBrowserHistory({
  basename: APP_BASE_URL,
});

export const rootReducer = combineReducers({
  // router
  router: connectRouter(history),
  // rtk query
  [baseApi.reducerPath]: baseApi.reducer,
  loginModalVisibility: LoginModalVisibilityReducer,
  registerModalState: RegisterModalReducer,
  topPageState: TopPageReducer,
  live: liveReducer,
  profilePageState: ProfilePageReducer,
  liveMission: LiveMissionReducer,
  liveMatch: LiveMatchReducer,
});
